<template>
<div class="conteudo-sistema">

	<div class="row">
		<div class="col-12 animated slideInDown">
			<h4>
				<fa-icon icon="bell" /> Notificações
			</h4>

			<button @click="clickModal(null)" class="btn btn-sm btn-outline-primary float-left">
				<fa-icon icon="plus"/> Nova
			</button>
		</div>
	</div>

	<flCarregando style="margin-top:20px" v-if="load" />

	<fl-table style="margin-top:20px"
				v-show="!load" ref="table"
				:perPage="10"
				class="animated fadeIn fast"
				@click-editar="clickModal"
				columnStartSortable="id"
				:columns="geraCabecalhos()" />

	<flModal @modal-hide="showForm = false" ref="cadastroNotificacao" width="50%" >
		<template v-slot:header>
			<span v-if="editar"><fa-icon icon="pen-alt"/> Editar</span>
			<span v-if="!editar"><fa-icon icon="plus"/> Nova</span>
		</template>
		<flCadastro v-if="showForm" ref="cadastro" @item-salvo="(item) => atualizaItem(item)" />
	</flModal>
</div>
</template>

<style scoped>

@media (max-width: 768px) {
	.table-responsive > div {
		width: 700px !important
	}
}
</style>

<script>
import _ from 'lodash'
import flCadastro from './cadastro.vue'
import flTable from '../../../components/table/main.vue'
import flModal from '../../../components/modal/main.vue'
import flCarregando from '../../../components/carregando/main.vue'
import axios from '../../../routers/axios'
export default {

	components: {
		flCadastro,
		flTable,
		flModal,
		flCarregando
	},


	data () {
		return {
			perfis: [],
			load: true,

			showForm: false,
			editar: false,
		}
	},

	mounted(){
		this.load = true
		axios.get(this._getUrl('api/perfil')).then(response => {

			this.perfis = response.data

			axios.get(this._getUrl('api/notificacaoconfig')).then(response => {

				response.data = response.data.map(item => {
					item.perfis = item.perfis.map(perfil => {
						return  _.find(this.perfis, p => {return p.id == perfil})
					})
					return item
				})

				let list = response.data.map(item => { return this.geraColunas(item) })

				this.$refs.table.loadTable(list)
				this.load = false
			})
		})
	},

	methods: {

        atualizaItem(item){

			item.perfis = item.perfis.map(perfil => {
				return  _.find(this.perfis, p => {return p.id == perfil})
			})

			item = this.geraColunas(item)
			this.$refs.table.atualizaItem(item, 'id', item._object.id)
			this.exibeCadastro = false
			this.$refs.cadastroNotificacao.hide()
			this.$notify.show('success', 'Notificação salva.')
		},

        clickModal(item){

			this.editar = item ? true : false
			this.showForm = true
			this.$refs.cadastroNotificacao.show()
			this.$nextTick(() => {
                this.$refs.cadastro.carregaDados(this.perfis, this.editar ? item._object : null)
			})
		},

		geraColunas(item){

			let itemLista = {}
			let columns = []

			// id
			columns.push({value: item.id })

			// nome
			columns.push({value: item.nome })

			// template
			columns.push({value: item.template })

			//sms
			columns.push({
				icon: item.sms ? ["fa", "check-circle"] : ["fa", "times-circle"],
				class: item.sms ? "text-success text-center" : "text-danger text-center"
			})

			// email
			columns.push({
				icon: item.email ? ["fa", "check-circle"] : ["fa", "times-circle"],
				class: item.email ? "text-success text-center" : "text-danger text-center"
			})

			// descricao
			columns.push({value: item.descricao })

			// perfis
			columns.push({
				array: item.perfis.map(item => {
					return `<div>${item.descricao}</div>`
				})
			})

			// editar
			columns.push({
				class: 'text-center',
				clickable: true,
				event: 'click-editar',
				icon: ["fa", "pen-alt"],
				styleIcon: 'font-size: 0.9rem',
			})

			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},

		geraCabecalhos(){
			let columns = []

			columns.push({
				name: 'ID',
				key: 'id',
				searchable: true,
				sortable: true,
				width: '8%',
			})

			columns.push({
				name: 'Nome',
				key: 'nome',
				searchable: true,
				sortable: true,
				width: '8%',
			})

			columns.push({
				name: 'Template',
				key: 'template',
				searchable: true,
				sortable: true,
				width: '8%',
			})

			columns.push({
				name: 'SMS',
				key: 'sms',
				searchable: false,
				sortable: false,
				class: 'text-center',
				width: '20%',
			})


			columns.push({
				name: 'SMS',
				key: 'sms',
				searchable: false,
				sortable: false,
				class: 'text-center',
				width: '20%',
			})

			columns.push({
				name: 'Descrição',
				key: 'descricao',
				searchable: true,
				sortable: true,
				width: '20%',
			})

			columns.push({
				name: 'Perfis',
				key: 'perfis',
				searchable: true,
				sortable: true,
				width: '20%',
			})

			columns.push({
				name: 'Editar',
				key: 'editar',
				searchable: false,
				sortable: false,
				class: 'text-center',
				width: '8%',
			})

			return columns
		},

	}
}
</script>




// WEBPACK FOOTER //
// src/views/adm/notificacao-config/main.vue